import httpService from '@/utils/request'
import { contextPath } from '@/config/'
export const querySubjectContentListApi = (params) => {
  return httpService({
    url: contextPath + '/subject/content/info',
    method: 'get',
    params
  })
}

export const addSubjectContentApi = (params, data) => {
  return httpService({
    url: contextPath + '/subject/content/list',
    method: 'post',
    params,
    data
  })
}

export const deleteSubjectItemApi = (params, data) => {
  return httpService({
    url: contextPath + '/subject/content/list',
    method: 'delete',
    params,
    data
  })
}

export const updateSubjectItemApi = (data) => {
  return httpService({
    url: contextPath + '/subject/item',
    method: 'put',
    data
  })
}


export const updateRSubjectItemApi = (params) => {
  return httpService({
    url: contextPath + '/subject/content/item/changeSubject',
    method: 'put',
    params
  })
}


export const uploadByExcelApi = (params,data) => {
  return httpService({

    url: contextPath + '/subject/content/list/uploadByExcel',
    method: 'post',
    params,
    data,
    apiType: 'file'
  })
}


export const downLoadByBatchApi = (params, data) => {
  return httpService({
    url: contextPath + '/subject/content/list/exportByBatch',
    method: 'post',
    params,
    data,
    responseType:'blob'
  })
}


export const downLoadByBatchAll = (params) => {
  return httpService({
    url: contextPath + '/subject/content/list/exportAll',
    method: 'get',
    params,
    responseType:'blob'
  })
}


export const updateUserApi = (params) => {
  return httpService({
    url: contextPath + '/subject/content/list/exportAll',
    method: 'get',
    params,
    responseType:'blob'
  })
}
